import React from 'react';
import { isNil } from 'lodash';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import { setDateFormat } from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { Columns } from '../../../../../types/common/table';
import { EventItemV2, EVENT_STATUS_V2 } from '../../../../../types/event';
import {
  EVENT_STATUS_LABEL_V2,
  EVENT_STATUS_SELECT_LIST_V2,
} from '../../../../../constants/service/app/eventConstantsV2';
import TableColumnModalImg from '../../../../../components/table/TableColumModalImg';
import { WidgetEventFilterOption } from '../../../../../types/widget';
import TableSelect from '../../../../../components/table/TableSelect';

export const eventReactTableColumns: Columns<EventItemV2, WidgetEventFilterOption> = (data) => {
  const { filterOption, onFilter } = data;
  return [
    {
      accessor: 'url',
      Header: '이미지',
      width: 100,
      fixed: 'left',
      Cell: (row) => <TableColumnModalImg url={row.value} />,
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: !!filterOption,
      width: 90,
      fixed: 'left',
      Cell: (row) => EVENT_STATUS_LABEL_V2[row.value as EVENT_STATUS_V2],
      Filter: () => (
        <TableSelect
          value={filterOption.status || ''}
          list={EVENT_STATUS_SELECT_LIST_V2}
          onChange={(value): void => {
            onFilter({ status: value as EVENT_STATUS_V2 });
          }}
        />
      ),
    },
    {
      accessor: 'id',
      Header: '기획전 ID',
      filterable: !!filterOption,
      width: 90,
      fixed: 'left',
      Filter: () => (
        <TableFilterInput
          type="number"
          option={filterOption.id}
          onFilter={(id: string): void => onFilter({ id: isNil(id) ? id : Number(id) })}
        />
      ),
    },
    {
      accessor: 'mainTitle',
      Header: '제목',
      filterable: !!filterOption,
      width: 250,
      fixed: 'left',
      Filter: () => (
        <TableFilterInput option={filterOption.mainTitle} onFilter={(mainTitle: string) => onFilter({ mainTitle })} />
      ),
    },
    {
      accessor: 'eventPeriod',
      Header: '기간',
      width: 320,
      Cell: (row) =>
        row.original.status === EVENT_STATUS_V2.UNLIMITED
          ? EVENT_STATUS_LABEL_V2[row.original.status as EVENT_STATUS_V2]
          : `${setDateFormat(row.original.startDate, DATE_FORMAT.FULL_DASH_FORMAT)} -\n ${setDateFormat(
              row.original.endDate,
              DATE_FORMAT.FULL_DASH_FORMAT,
            )} `,
    },
    {
      accessor: 'contents',
      Header: '기획전 본문',
      width: 300,
      filterable: !!filterOption,
      Filter: () => (
        <TableFilterInput option={filterOption.contents} onFilter={(contents: string) => onFilter({ contents })} />
      ),
    },
    {
      accessor: 'memo',
      Header: '메모',
      width: 300,
      filterable: !!filterOption,
      Filter: () => <TableFilterInput option={filterOption.memo} onFilter={(memo: string) => onFilter({ memo })} />,
    },
  ];
};
